module.exports = __webpack_public_path__ + "img/paint.fec598fc.svg";